import React from "react"

export default class CreditCard extends React.Component{
  
  constructor(props){
    super(props)
  }

  render(){
    return(
      <div className="card well">
        <label>
          <span className={"credit-card-icon small " + this.props.card.brand}></span>
          <strong>{I18n.t(this.props.card.brand)}</strong> {I18n.t('ending_in').toLowerCase()} <strong>{this.props.card.last_4} {I18n.t('exp_date')} {this.props.card.month}/{this.props.card.year}</strong>
        </label>
      </div>
    )
  }

}